import { assetsPath } from "../../utils";

const baseAssetUrl = assetsPath("laguna-seaside-residences");

const img1 = `${baseAssetUrl}/images/concept/1.jpg`;
const img2 = `${baseAssetUrl}/images/concept/2.jpg`;
const img3 = `${baseAssetUrl}/images/concept/3.jpg`;
const img4 = `${baseAssetUrl}/images/concept/4.jpg`;

const imageSlider = [
  { image: img1 },
  { image: img2 },
  { image: img3 },
  { image: img4 },
];

const content = {
  en: `<h2 style="text-align: center;margin-top: 60px;">BEACH RESORT LIVING</h2>
    <p>Located within Laguna Phuket and a few short steps to Bangtao Beach, Laguna Seaside Residences is the newest address in Asia’s finest intergrated resort.</p>
    <br />
    <p>The development is ideally positioned just a few metres from the beach itself and features a dedicated beach area which offers owners the best seats in the house to enjoy the stunning sunset over the light - speckled waters of the Andaman Sea.</p>
    <br />
    <p>A unique roof top recreation area provides a communal space for residents to enjoy the tropical outdoors, enriching their lifestyle, and adding to the development’s carefree beach resort vibe.</p>`,
  cn: `<h2 style="text-align: center;margin-top: 40px;">海滨度假生活</h2>
    <p>全新的乐古浪海滨住宅位于亚洲顶级综合度假村普吉乐古浪，距离邦涛海滩仅几步之遥。</p>
    <br />
    <p>该项目地理位置优越，距离海滩只有数米并拥有一个专属海滩区，为业主提供欣赏安达曼海上壮观落日的绝佳位置。</p>
    <br />
    <p>独特的屋顶休闲区为居民提供一个享受热带户外环境的公共空间，丰富他们的生活方式，也营造出闲适惬意的海滩度假氛围。</p>`,
  ru: `<h2 style="text-align: center;margin-top: 40px;">Жизнь на пляжном курорте</h2>
    <p>Laguna Seaside Residences — это новый жилой комплекс в Лагуна Пхукет – в лу чшем интегрированном курорте Азии и в шаговой доступности от пляжа Бангтао</p>
    <br />
    <p>Жилой комплекс идеально расположен всего в нескольких метрах от пляжа и включает отдельную пляжную зону, откуда владельцы могут насладиться лучшими видами на закат солнца над искрящимися водами Андаманского моря.</p>
    <br />
    <p>На крыше всех четырех малоэтажных зданий Laguna Seaside Residences расположена уникальная зона общего пользования, где жители комплекса могут отдохнуть на открытом воздухе среди тропиков, разнообразя свой образ жизни и внося вклад в оживленную и беззаботную атмосферу пляжного курорта.</p>`,
};

export default {
  imageSlider,
  content,
};



// WEBPACK FOOTER //
// ./src/data/LagunaSeasideResidences/concept.js